/**
 * Llamadas de la sesion del backoffice (ADM-01).
 */
import type {
  Administrador,
  CambiarClaveDto,
  CredencialesDto,
  CrearAdministradorDto,
  RespuestaAcceso,
} from '@bandu/compartido';

import { pedir } from './cliente-api';

export function abrirSesion(credenciales: CredencialesDto): Promise<RespuestaAcceso> {
  return pedir<RespuestaAcceso>('/admin/sesion', { metodo: 'POST', cuerpo: credenciales });
}

/** Comprueba si el token guardado en el navegador todavia vale. */
export function obtenerSesion(senal?: AbortSignal): Promise<Administrador> {
  return pedir<Administrador>('/admin/sesion', { ...(senal ? { senal } : {}) });
}

export function cambiarClave(datos: CambiarClaveDto): Promise<Administrador> {
  return pedir<Administrador>('/admin/clave', { metodo: 'POST', cuerpo: datos });
}

export function obtenerAdministradores(senal?: AbortSignal): Promise<Administrador[]> {
  return pedir<Administrador[]>('/admin/administradores', { ...(senal ? { senal } : {}) });
}

export function crearAdministrador(datos: CrearAdministradorDto): Promise<Administrador> {
  return pedir<Administrador>('/admin/administradores', { metodo: 'POST', cuerpo: datos });
}

export function cambiarEstadoAdministrador(id: number, activo: boolean): Promise<Administrador> {
  return pedir<Administrador>(`/admin/administradores/${id}`, {
    metodo: 'PATCH',
    cuerpo: { activo },
  });
}

/**
 * Baja definitiva de una cuenta. Convive con desactivar y no la reemplaza:
 * desactivar es reversible, esto no.
 */
export function eliminarAdministrador(id: number): Promise<void> {
  return pedir<void>(`/admin/administradores/${id}`, { metodo: 'DELETE' });
}
